import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { saveSubscription } from "../actions";
import SubscriptionForm from "../components/SubscriptionForm";
import { FormMenu } from "../../../components/Buttons";
import { scrollToTop } from "../../../components/Utils";

const mapStateToProps = (state) => {
  return {
    user: state.auth.userProfile,
  };
};
const mapDispatchToProps = (dispatch) => ({
  saveSubscription: (...args) => dispatch(saveSubscription(...args)),
});

function NewsSubscriptionPanel({
  className = "",
  user,
  disabled,
  saveSubscription,
}) {
  const formRef = React.useRef(null);

  React.useEffect(() => {
    scrollToTop();
  });

  const onSave = React.useCallback(() => {
    const model = formRef.current.getModel();
    saveSubscription && saveSubscription(model);
  }, [saveSubscription]);

  if (!user) return null;
  return (
    <div className={className}>
      <SubscriptionForm
        ref={formRef}
        model={user}
        disabled={disabled}
        onSave={onSave}
      />
      <FormMenu
        className="neg-margin-big-lr neg-margin-big-btm margin-top w3-border-top pad-big w3-light-grey"
        onSave={onSave}
        cancelHidden
        saveBtnName="saveNewsSettingsBtn"
        saveHidden={disabled}
        saveDisabled={disabled}
      />
    </div>
  );
}

NewsSubscriptionPanel.propTypes = {
  user: PropTypes.object,
  saveSubscription: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewsSubscriptionPanel);
